/**
 * enum for different Languages that are used for translation
 */
export enum Language {
  DE = 'DE',
  EN = 'EN',
  CZ = 'CZ',
  SK = 'SK',
}
